// src/components/careers/CtaSection.tsx
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface CtaSectionProps {
  onOpenModal: () => void;
}

export function CtaSection({ onOpenModal }: CtaSectionProps) {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-white dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-6">
          {t('careers.cta.title', 'Your Future Starts Here')}
        </h3>
        <p className="text-lg text-slate-600 dark:text-slate-300 mb-8 max-w-2xl mx-auto">
          {t('careers.cta.description', 'Be part of something bigger. Join Oleyes Security and help us secure the world with AI and cloud technology.')}
        </p>
        <Button
          onClick={onOpenModal}
          className="px-7 py-3 bg-slate-900 hover:bg-slate-600 text-white dark:bg-white dark:text-slate-900 font-bold tracking-wide"
        >
          {t('careers.cta.button', 'View Open Positions')}
        </Button>
      </div>
    </section>
  );
}